// extracted by mini-css-extract-plugin
export default {"listItem":"_30fY52UTSWXUPeaiOSXLlZ","link":"_55Kb1WjEHGq5EWWTrpJa6T"};